// Generated by ReScript, PLEASE EDIT WITH CARE

import * as I18n from "../../primitives/I18n.res.js";
import * as React from "react";
import * as Future from "rescript-future/src/Future.res.js";
import * as Pervasives from "@rescript/runtime/lib/es6/Pervasives.js";
import * as ApolloHelpers from "../../helpers/ApolloHelpers.res.js";
import * as Client from "@apollo/client";
import * as JsxRuntime from "react/jsx-runtime";
import * as CatalogVariantStockThresholdForm from "./CatalogVariantStockThresholdForm.res.js";
import * as ApolloClient__React_Hooks_UseMutation from "rescript-apollo-client/src/@apollo/client/react/hooks/ApolloClient__React_Hooks_UseMutation.res.js";

let Raw = {};

let query = Client.gql(["mutation updateVariant_stockThresholds($id: ID!, $input: InputUpdateVariant!)  {\nupdateVariant(id: $id, input: $input)  {\n__typename  \nid  \nmaxStockThreshold  \nminStockThreshold  \nstockOrderTriggerThreshold  \nstock  {\n__typename  \nformattedQuantity  \nstate  \nformattedShopsNames  \n}\n\n}\n\n}\n"]);

function parse(value) {
  let value$1 = value.updateVariant;
  let value$2 = value$1.maxStockThreshold;
  let value$3 = value$1.minStockThreshold;
  let value$4 = value$1.stockOrderTriggerThreshold;
  let value$5 = value$1.stock;
  let value$6 = value$5.formattedQuantity;
  let value$7 = value$5.state;
  let tmp;
  if (value$7 == null) {
    tmp = undefined;
  } else {
    let tmp$1;
    switch (value$7) {
      case "ALERT" :
        tmp$1 = "ALERT";
        break;
      case "DANGER" :
        tmp$1 = "DANGER";
        break;
      case "OK" :
        tmp$1 = "OK";
        break;
      default:
        throw {
          RE_EXN_ID: "Not_found",
          Error: new Error()
        };
    }
    tmp = tmp$1;
  }
  let value$8 = value$5.formattedShopsNames;
  return {
    updateVariant: {
      __typename: value$1.__typename,
      id: value$1.id,
      maxStockThreshold: !(value$2 == null) ? value$2 : undefined,
      minStockThreshold: !(value$3 == null) ? value$3 : undefined,
      stockOrderTriggerThreshold: !(value$4 == null) ? value$4 : undefined,
      stock: {
        __typename: value$5.__typename,
        formattedQuantity: !(value$6 == null) ? value$6 : undefined,
        state: tmp,
        formattedShopsNames: !(value$8 == null) ? value$8 : undefined
      }
    }
  };
}

function serialize(value) {
  let value$1 = value.updateVariant;
  let value$2 = value$1.stock;
  let value$3 = value$2.formattedShopsNames;
  let formattedShopsNames = value$3 !== undefined ? value$3 : null;
  let value$4 = value$2.state;
  let state = value$4 !== undefined ? (
      value$4 === "OK" ? "OK" : (
          value$4 === "ALERT" ? "ALERT" : "DANGER"
        )
    ) : null;
  let value$5 = value$2.formattedQuantity;
  let formattedQuantity = value$5 !== undefined ? value$5 : null;
  let value$6 = value$2.__typename;
  let stock = {
    __typename: value$6,
    formattedQuantity: formattedQuantity,
    state: state,
    formattedShopsNames: formattedShopsNames
  };
  let value$7 = value$1.stockOrderTriggerThreshold;
  let stockOrderTriggerThreshold = value$7 !== undefined ? value$7 : null;
  let value$8 = value$1.minStockThreshold;
  let minStockThreshold = value$8 !== undefined ? value$8 : null;
  let value$9 = value$1.maxStockThreshold;
  let maxStockThreshold = value$9 !== undefined ? value$9 : null;
  let value$10 = value$1.id;
  let value$11 = value$1.__typename;
  let updateVariant = {
    __typename: value$11,
    id: value$10,
    maxStockThreshold: maxStockThreshold,
    minStockThreshold: minStockThreshold,
    stockOrderTriggerThreshold: stockOrderTriggerThreshold,
    stock: stock
  };
  return {
    updateVariant: updateVariant
  };
}

function serializeInputObjectInputUpdateVariantMetaData(inp) {
  let a = inp.shopifyVariantId;
  return {
    shopifyVariantId: a !== undefined ? a : undefined
  };
}

function serializeInputObjectInputUpdateVariant(inp) {
  let a = inp.stockKeepingUnit;
  let a$1 = inp.name;
  let a$2 = inp.purchasedPrice;
  let a$3 = inp.year;
  let a$4 = inp.capacityValue;
  let a$5 = inp.capacityUnit;
  let a$6 = inp.capacityPrecision;
  let a$7 = inp.alcoholVolume;
  let a$8 = inp.ean13;
  let a$9 = inp.internalNote;
  let a$10 = inp.metadata;
  let a$11 = inp.tastingNote;
  let a$12 = inp.packaging;
  let a$13 = inp.internalCode;
  let a$14 = inp.priceLookUpCode;
  let a$15 = inp.supplierId;
  let a$16 = inp.minStockThreshold;
  let a$17 = inp.maxStockThreshold;
  let a$18 = inp.stockOrderTriggerThreshold;
  return {
    stockKeepingUnit: a !== undefined ? a : undefined,
    name: a$1 !== undefined ? a$1 : undefined,
    purchasedPrice: a$2 !== undefined ? a$2 : undefined,
    year: a$3 !== undefined ? a$3 : undefined,
    capacityValue: a$4 !== undefined ? a$4 : undefined,
    capacityUnit: a$5 !== undefined ? a$5 : undefined,
    capacityPrecision: a$6 !== undefined ? a$6 : undefined,
    alcoholVolume: a$7 !== undefined ? a$7 : undefined,
    ean13: a$8 !== undefined ? a$8 : undefined,
    internalNote: a$9 !== undefined ? a$9 : undefined,
    metadata: a$10 !== undefined ? serializeInputObjectInputUpdateVariantMetaData(a$10) : undefined,
    tastingNote: a$11 !== undefined ? a$11 : undefined,
    packaging: a$12 !== undefined ? a$12 : undefined,
    internalCode: a$13 !== undefined ? a$13 : undefined,
    priceLookUpCode: a$14 !== undefined ? a$14 : undefined,
    supplierId: a$15 !== undefined ? a$15 : undefined,
    minStockThreshold: a$16 !== undefined ? a$16 : undefined,
    maxStockThreshold: a$17 !== undefined ? a$17 : undefined,
    stockOrderTriggerThreshold: a$18 !== undefined ? a$18 : undefined
  };
}

function serializeVariables(inp) {
  return {
    id: inp.id,
    input: serializeInputObjectInputUpdateVariant(inp.input)
  };
}

function makeVariables(id, input, param) {
  return {
    id: id,
    input: input
  };
}

function makeInputObjectInputUpdateVariant(stockKeepingUnit, name, purchasedPrice, year, capacityValue, capacityUnit, capacityPrecision, alcoholVolume, ean13, internalNote, metadata, tastingNote, packaging, internalCode, priceLookUpCode, supplierId, minStockThreshold, maxStockThreshold, stockOrderTriggerThreshold, param) {
  return {
    stockKeepingUnit: stockKeepingUnit,
    name: name,
    purchasedPrice: purchasedPrice,
    year: year,
    capacityValue: capacityValue,
    capacityUnit: capacityUnit,
    capacityPrecision: capacityPrecision,
    alcoholVolume: alcoholVolume,
    ean13: ean13,
    internalNote: internalNote,
    metadata: metadata,
    tastingNote: tastingNote,
    packaging: packaging,
    internalCode: internalCode,
    priceLookUpCode: priceLookUpCode,
    supplierId: supplierId,
    minStockThreshold: minStockThreshold,
    maxStockThreshold: maxStockThreshold,
    stockOrderTriggerThreshold: stockOrderTriggerThreshold
  };
}

function makeInputObjectInputUpdateVariantMetaData(shopifyVariantId, param) {
  return {
    shopifyVariantId: shopifyVariantId
  };
}

let UpdateVariantStockThresholdsMutation_inner = {
  Raw: Raw,
  query: query,
  parse: parse,
  serialize: serialize,
  serializeVariables: serializeVariables,
  serializeInputObjectInputUpdateVariant: serializeInputObjectInputUpdateVariant,
  serializeInputObjectInputUpdateVariantMetaData: serializeInputObjectInputUpdateVariantMetaData,
  makeVariables: makeVariables,
  makeInputObjectInputUpdateVariant: makeInputObjectInputUpdateVariant,
  makeInputObjectInputUpdateVariantMetaData: makeInputObjectInputUpdateVariantMetaData
};

let include = ApolloClient__React_Hooks_UseMutation.Extend({
  query: query,
  Raw: Raw,
  parse: parse,
  serialize: serialize,
  serializeVariables: serializeVariables
});

let use = include.use;

let UpdateVariantStockThresholdsMutation_useWithVariables = include.useWithVariables;

let UpdateVariantStockThresholdsMutation = {
  UpdateVariantStockThresholdsMutation_inner: UpdateVariantStockThresholdsMutation_inner,
  Raw: Raw,
  query: query,
  parse: parse,
  serialize: serialize,
  serializeVariables: serializeVariables,
  serializeInputObjectInputUpdateVariant: serializeInputObjectInputUpdateVariant,
  serializeInputObjectInputUpdateVariantMetaData: serializeInputObjectInputUpdateVariantMetaData,
  makeVariables: makeVariables,
  makeInputObjectInputUpdateVariant: makeInputObjectInputUpdateVariant,
  makeInputObjectInputUpdateVariantMetaData: makeInputObjectInputUpdateVariantMetaData,
  use: use,
  useWithVariables: UpdateVariantStockThresholdsMutation_useWithVariables
};

function validateMinStockThreshold(param) {
  let minStockThreshold = param.minStockThreshold;
  if (minStockThreshold > param.stockOrderTriggerThreshold) {
    return {
      TAG: "Error",
      _0: I18n.t("The minimum stock should be less or equal to the value triggering a new order.")
    };
  } else if (minStockThreshold >= param.maxStockThreshold) {
    return {
      TAG: "Error",
      _0: I18n.t("The minimum stock should be less than the maximum stock.")
    };
  } else {
    return {
      TAG: "Ok",
      _0: undefined
    };
  }
}

function validateStockOrderTriggerThreshold(param) {
  let maxStockThreshold = param.maxStockThreshold;
  if (maxStockThreshold !== 0) {
    if (param.stockOrderTriggerThreshold >= maxStockThreshold) {
      return {
        TAG: "Error",
        _0: I18n.t("This value should be less than maximum stock value.")
      };
    } else {
      return {
        TAG: "Ok",
        _0: undefined
      };
    }
  } else {
    return {
      TAG: "Error",
      _0: I18n.t("You have to define the maximum stock beforehand.")
    };
  }
}

let schema = [
  {
    TAG: "Custom",
    _0: "MinStockThreshold",
    _1: validateMinStockThreshold
  },
  {
    TAG: "Custom",
    _0: "StockOrderTriggerThreshold",
    _1: validateStockOrderTriggerThreshold
  }
];

function CatalogVariantStockThresholdFormContainer(props) {
  let variantId = props.variantId;
  let formPropState = CatalogVariantStockThresholdForm.useFormPropState({
    id: variantId,
    initialValues: {
      maxStockThreshold: props.maxStockThreshold,
      minStockThreshold: props.minStockThreshold,
      stockOrderTriggerThreshold: props.stockOrderTriggerThreshold
    },
    schema: schema
  });
  let match = use(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined);
  let mutate = match[0];
  let commit = React.useCallback(param => {
    let input = makeInputObjectInputUpdateVariant(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, param.minStockThreshold | 0, param.maxStockThreshold | 0, param.stockOrderTriggerThreshold | 0, undefined);
    let id = variantId === "" ? Pervasives.failwith("There is no variant id found here.") : variantId;
    return Future.mapOk(ApolloHelpers.mutationPromiseToFutureResult(mutate(undefined, undefined, undefined, undefined, undefined, undefined, undefined, {
      id: id,
      input: input
    })), undefined, param => param.updateVariant.id);
  }, [variantId]);
  return JsxRuntime.jsxs(CatalogVariantStockThresholdForm.Core.Provider.make, {
    children: [
      JsxRuntime.jsx(CatalogVariantStockThresholdForm.AutoSave.make, {
        onSubmit: (param, values) => commit(values),
        disabled: match[1].loading
      }),
      props.children
    ],
    propState: formPropState
  });
}

let make = React.memo(CatalogVariantStockThresholdFormContainer);

export {
  UpdateVariantStockThresholdsMutation,
  validateMinStockThreshold,
  validateStockOrderTriggerThreshold,
  schema,
  make,
}
/* query Not a pure module */
